export enum Sites {
  Stdcheck = 'STDcheck',
  Healthlabs = 'HealthLabs',
  Treatmyuti = 'TreatMyUTI',
  Starfish = 'Starfish',
  Stallion = 'Stallion',
  TestosteroneHq = 'TestosteroneHQ',
  AnalyteHealth = 'AnalyteHealth',
}
